import PropTypes from "prop-types";
import { useState } from "react";
import Modal from "components/shared/stays/Modal";
import ModalBody from "components/shared/stays/ModalBody";
import ModalHeader from "components/shared/stays/ModalHeader";
import ModalFooter from "components/shared/stays/ModalFooter";
import Button from "solar/components/Button";
import Counter from "components/shared/stays/Counter";
import Title from "components/shared/stays/Title";
import Text from "components/shared/stays/Text";
import styles from "components/shared/stays/ChooseTravelers.module.scss";

export default function ChooseTravelers({
  show,
  handleClose,
  setNumTravelers,
  privateGroupQuantity = null,
  travelers = { adults: 1, children: 0, infants: 0 },
}) {
  const [currentNumAdults, setCurrentNumAdults] = useState(travelers.adults);
  const [currentNumChildren, setCurrentNumChildren] = useState(
    travelers.children
  );
  const [currentNumInfants, setCurrentNumInfants] = useState(travelers.infants);

  function handleSave() {
    setNumTravelers({
      adults: currentNumAdults,
      children: currentNumChildren,
      infants: currentNumInfants,
    });
    handleClose();
  }

  function handleClearTravelers() {
    setNumTravelers({
      adults: 1,
      children: 0,
      infants: 0,
    });
    handleClose();
  }

  return (
    <Modal show={show} handleClose={handleClose} className={styles.modal}>
      <ModalHeader>
        <Title size={4}>Select travelers</Title>
      </ModalHeader>
      <ModalBody>
        <div className={styles.body}>
          <div className={styles.actions}>
            <Counter
              initialCount={travelers.adults}
              setCurrentCount={setCurrentNumAdults}
              title="Adults"
              minCount={1}
            />
            <Counter
              initialCount={travelers.children}
              setCurrentCount={setCurrentNumChildren}
              title="Children"
              hint="Ages 2-12"
            />
            <Counter
              initialCount={travelers.infants}
              setCurrentCount={setCurrentNumInfants}
              title="Infants"
              hint="Under 2"
            />
          </div>
          <div className={styles.note}>
            <Text>
              {privateGroupQuantity ? (
                `For private groups of any size, up to ${privateGroupQuantity} travelers. Infants don’t count toward the number of travelers.`
              ) : (
                <>Infants don’t count toward the number of travelers.</>
              )}
            </Text>
          </div>
        </div>
      </ModalBody>
      <ModalFooter bordered>
        <div className={styles.footer}>
          <div>
            <Button link size={2} onClick={handleClearTravelers}>
              Clear travelers
            </Button>
          </div>
          <div>
            <Button size={2} onClick={handleSave}>
              Save
            </Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
}

ChooseTravelers.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setNumTravelers: PropTypes.func.isRequired,
  privateGroupQuantity: PropTypes.number,
  travelers: PropTypes.shape({
    adults: PropTypes.number,
    children: PropTypes.number,
    infants: PropTypes.number,
  }),
};
